import React, { useMemo } from 'react';
import { useGetSiteData } from './helper';
import { useGetIDsFromURL } from 'components/DeviceDetails/helper';
import HGChart from 'components/HGChart';
import TabbedCard from 'components/DeviceDetails/TabbedCard';
import NoDevicesAvailable from './NoDevicesAvailable';
import DevicesTable from './DevicesTable';
import HGProfile from 'components/HGProfile';
import { ProfileTypes } from 'components/DeviceDetails/constants';

const SiteDetails = () => {
    const { Site_ID } = useGetIDsFromURL();
    const { data: siteData, isLoading } = useGetSiteData(Site_ID);
    const devices = useMemo(
        () => siteData?.Things?.items ?? [],
        [siteData?.Things?.items]
    );

    const tabConfig = useMemo(
        () => [
            {
                title: 'Site Profile',
                component: (
                    <HGProfile
                        title="Site Profile"
                        profileType={ProfileTypes.Sites}
                    />
                ),
            },
            {
                title: 'Devices',
                component:
                    isLoading || devices.length > 0 ? (
                        <DevicesTable />
                    ) : (
                        <NoDevicesAvailable />
                    ),
            },
        ],
        [devices, isLoading]
    );

    return (
        <div className="flex flex-col gap-5">
            <HGChart devices={devices} />
            <TabbedCard tabConfig={tabConfig} />
        </div>
    );
};
export default SiteDetails;
